import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 59F26CDB-B593-4675-941C-68F0E99F2CFF
 * name numeric-10
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-10.svg
 * tags
 * - Alpha / Numeric 
 */
export const Numeric10Icon = createSvgIcon(<><path d="M10 7H6V9H8V17H10V7M16 7H14C12.9 7 12 7.9 12 9V15C12 16.11 12.9 17 14 17H16C17.11 17 18 16.11 18 15V9C18 7.9 17.11 7 16 7M16 15H14V9H16V15Z" /></>, 'Numeric10Icon');
export default Numeric10Icon